// @flow
import * as React from 'react';

import AdminAutoMessageSftpCredentialsContainer from './AdminAutoMessageSftpCredentialsContainer';
import AdminAutoMessageSftpCredentialsView from './AdminAutoMessageSftpCredentialsView';

type Props = {
  viewingOrgUuid: string,
};

export default class AdminAutoMessageSftpCredentials extends React.Component<Props, *> {
  render() {
    const { viewingOrgUuid } = this.props;

    return (
      <AdminAutoMessageSftpCredentialsContainer viewingOrgUuid={viewingOrgUuid}>
        {props => (
          <AdminAutoMessageSftpCredentialsView {...props} viewingOrgUuid={viewingOrgUuid} />
        )}
      </AdminAutoMessageSftpCredentialsContainer>
    );
  }
}
